// react
import { useState } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// dialogs
import { DialogActions } from '../DialogActions/DialogActions';

// forms
import { FormEditComponent } from '../../forms/FormEditComponent/FormEditComponent';

// props
export interface DialogEditComponentProps {
	isOpen: boolean;
	onClose: () => void;
	onSuccess?: () => void;
}

export const DialogEditComponent = ({ isOpen, onClose, onSuccess }: DialogEditComponentProps) => {
	// hooks
	const { t } = useTranslation();

	// state
	const [isLoading, setIsLoading] = useState(false);

	return (
		<DialogActions
			actions={[
				{
					children: t('cancel'),
					onClick: onClose,
				},
				{
					children: t('saveComponent'),
					loading: isLoading,
					form: 'form-edit-component',
					type: 'submit',
					variant: 'contained',
				},
			]}
			hasClose={true}
			isOpen={isOpen}
			maxWidth={700}
			onClose={onClose}
			title={{
				children: t('editComponent'),
				variant: 'h3',
			}}>
			<FormEditComponent onClose={onClose} onSuccess={onSuccess} setIsLoading={setIsLoading} />
		</DialogActions>
	);
};
